export function toInt(value: string | number | null | undefined): number {
  return parseInt(String(value)) || 0;
}
